// Hücre köşesi not simgesi (portal yetki v2 Dalga 3, spec §6): sayı + karşı taraftan okunmamış
// mesaj varsa nokta. Tıklama hücre editörünü açmaz (stopPropagation) — thread penceresini açar.
// Not YOKKEN simge fare ipucudur (T12): `aria-hidden` (ekran okuyucu her yaprak hücrede "Not ekle"
// okumaz; klavye yolu editör/formül penceresindeki "Not ekle") ve hücrenin sağ üst köşesinde akış
// dışında durur (globals.css) — hücrenin ortasına tıklamak değer editörünü açar.
// Kopya: kpi-notes-copy.ts (müşteri yüzeyinde "AI/üretim/danışman notu" geçmez).

import { KPI_NOTES_COPY } from "../../lib/kpi-notes-copy";

export function KpiCellNoteBadge(props: {
  audience: "portal" | "internal";
  count: number;
  unread: number;
  onOpen: () => void;
}): JSX.Element | null {
  const { audience, count, unread, onOpen } = props;
  // Not yoksa: "Not ekle" simgesi (satır/hücre üzerine gelince ya da odakta görünür; Tab sırasına girmez —
  // klavye yolu hücre editöründeki / formül penceresindeki "Not ekle" düğmesidir). Boş/türetilmiş hücrede
  // de iş parçacığı başlatılabilsin (spec §6).
  const empty = count <= 0;
  const label = empty
    ? KPI_NOTES_COPY[audience].addNote
    : KPI_NOTES_COPY[audience].badgeLabel(count, unread > 0);
  return (
    <button
      type="button"
      data-testid="kpi-note-badge"
      className={empty ? "kpi-note-badge--empty" : undefined}
      data-empty={empty ? "true" : "false"}
      {...(empty ? { tabIndex: -1, "aria-hidden": true } : {})}
      data-unread={unread > 0 ? "true" : "false"}
      aria-label={label}
      title={label}
      onClick={(e) => {
        e.stopPropagation();
        onOpen();
      }}
      style={{
        display: "inline-block",
        marginLeft: 6,
        padding: "0 6px",
        borderRadius: 999,
        border: "1px solid transparent",
        background: "transparent",
        color: "var(--color-text-3)",
        fontSize: "0.7rem",
        lineHeight: "16px",
        verticalAlign: "middle",
        cursor: "pointer",
        minHeight: 18,
      }}
    >
      {/* Not yokken simge CSS ::before ile çizilir (metin düğümü yok → hücre metni/kopyalama kirlenmez) */}
      {empty ? null : (
        <>
          <span aria-hidden="true">💬</span> {count}
        </>
      )}
      {unread > 0 ? (
        <span
          aria-hidden="true"
          style={{
            display: "inline-block",
            width: 7,
            height: 7,
            marginLeft: 4,
            borderRadius: "50%",
            background: "var(--color-primary)",
            verticalAlign: "middle",
          }}
        />
      ) : null}
    </button>
  );
}
